// src/components/news/CreateNewsForm/CreateNewsForm.js
import { useState } from 'react';
import api from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const CreateNewsForm = ({ onNewsCreated, show, onClose }) => {
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    project_id: ''
  });
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [fetchingProjects, setFetchingProjects] = useState(false);

  // Загрузка списка проектов
  const fetchProjects = async () => {
    if (projects.length > 0 || fetchingProjects) return;
    setFetchingProjects(true);
    try {
      const res = await api.get('/projects');
      if (Array.isArray(res.data.projects)) {
        setProjects(res.data.projects);
      }
    } catch (err) {
      console.error('Ошибка загрузки проектов:', err);
      // Ошибки обрабатываются глобально
    } finally {
      setFetchingProjects(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        title: formData.title.trim(),
        message: formData.message.trim(),
        project_id: formData.project_id === '' ? null : parseInt(formData.project_id)
      };

      if (!payload.title || !payload.message) {
        // Ошибки валидации обрабатываются на уровне формы
        return;
      }

      const res = await api.post('/news', payload);
      if (res.data.success) {
        setFormData({ title: '', message: '', project_id: '' });
        if (onNewsCreated) {
          onNewsCreated(res.data.news);
        }
        onClose(); // Автоматическое закрытие модального окна после успешного создания
      } else {
        throw new Error(res.data.message || 'Неизвестная ошибка');
      }
    } catch (err) {
      console.error('Ошибка создания новости:', err);
    } finally {
      setLoading(false);
    }
  };


  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
          <h3 style={{margin: 0}}>Создать новость</h3>
          <button className="btn-modal-close" onClick={onClose} aria-label="Закрыть">x</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title">Заголовок *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Сообщение *</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
              className="comment-textarea"
            />
          </div>
          <div className="form-group">
            <label htmlFor="project_id">Проект (необязательно)</label>
            <select
              id="project_id"
              name="project_id"
              value={formData.project_id}
              onChange={handleChange}
              onClick={fetchProjects}
            >
              <option value="">— Все пользователи —</option>
              {fetchingProjects ? (
                <option disabled>Загрузка проектов...</option>
              ) : (
                projects.map(project => (
                  <option key={project.id} value={project.id}>
                    {project.name_text}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="modal-actions">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? <><LoadingSpinner text="" /> Создание...</> : 'Создать новость'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNewsForm;